import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  activeModals: string[];
}

const initialState: ModalState = {
  activeModals: [],
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<string>) => {
      if (!state.activeModals.includes(action.payload)) {
        state.activeModals.push(action.payload);
      }
    },
    closeModal: (state, action: PayloadAction<string>) => {
      state.activeModals = state.activeModals.filter(
        (modal) => modal !== action.payload
      );
    },
    closeAllModals: (state) => {
      state.activeModals = [];
    },
  },
});

export const { openModal, closeModal, closeAllModals } = modalSlice.actions;
export default modalSlice.reducer;
